import { BaseTicketController } from '../../../../common/base/ticketController';
import _ from 'lodash';

const StandingOrderStatusNew = 'new';

export const StandingOrderTypes = {
  StandingOrders: 'standingOrders',
  AppointmentTransfers: 'appointmentTransfers',
};

export class StandingOrdersController extends BaseTicketController {
  constructor(
    controllerService,
    progressService,
    $scope,
    $q,
    ticketService,
    receivingListStateName,
    dataParser,
    fileResponseService,
  ) {
    'ngInject';
    super({
      controllerService,
      progressService,
      $scope,
      $q,
      ticketService,
      receivingListStateName,
      dataParser,
      fileResponseService,
    });
  }

  get acceptStandingOrderspecialDate() {
    return (
      this.ticket &&
      this.ticket.formValues &&
      this.ticket.formValues.acceptStandingOrderspecialDate
    );
  }

  get featureStandingOrdersDownload() {
    return this.isFeatureActive(this.FeatureNames.FF_STANDING_ORDERS_DOWNLOAD);
  }

  get standingOrderTypes() {
    return [
      StandingOrderTypes.StandingOrders,
      StandingOrderTypes.AppointmentTransfers,
    ];
  }

  $onInit() {
    super.$onInit();

    if (this.featureAddRemarkToStandingOrders) {
      this.remark = {};
      this.messages = {
        email: 'app.standingOrders.remark.error.invalid.email',
        required: 'app.standingOrders.remark.error.required',
      };
    }
    const { standingOrders, appointmentTransfers } =
      this.standingOrdersAndAppointmentTransfers;

    this.standingOrders = this.standingOrders =
      this.mapStandingOrders(standingOrders);
    this.appointmentTransfers = this.mapStandingOrders(appointmentTransfers);

    if (!this.standingOrders && !this.appointmentTransfers) {
      this.submit();
    }

    this.submitReady = this.standingOrderOpen();
  }

  handleStatusChange(item, newStatus) {
    item.isOpen = false;
    item.progressStatus = newStatus;

    const maybeNewItem = _.find(
      [...this.standingOrders, ...this.appointmentTransfers],
      (order) => order.progressStatus === 'new',
    );

    if (maybeNewItem) {
      maybeNewItem.isOpen = true;
    }

    this.ticketService
      .updateStandingOrderStatus(this.ticket.id, item.paymentPartnerId, {
        progressStatus: newStatus,
      })
      .finally(() => (this.submitReady = this.standingOrderOpen()));
  }

  mapStandingOrders(standingOrders) {
    const dateValues = [
      'firstExecutionDate',
      'nextExecutionDate',
      'lastExecutionDate',
    ];
    let firstOpenOrders = true;
    return standingOrders.map((order) => {
      dateValues.forEach((key) => {
        if (order[key]) {
          order[key] = this.dataParser.modifyDate(order[key], 'mediumDate');
        }
      });

      if (!order.progressStatus) {
        order.progressStatus = StandingOrderStatusNew;
      }

      // Open the first one
      if (firstOpenOrders && order.progressStatus === StandingOrderStatusNew) {
        order.isOpen = true;
        firstOpenOrders = false;
      }

      return order;
    });
  }

  standingOrderOpen() {
    return !_.some(
      this.standingOrders,
      (s) => s.progressStatus === StandingOrderStatusNew,
    );
  }

  downloadStandingOrdersCsv() {
    this.ticketService
      .downloadStandingOrdersCsv(this.ticket.id)
      .then((file) => this.fileResponseService.saveAs(file, 'application/csv'))
      .busy(this, 'standingOrdersDownloading')
      .finally(() => {
        this.submitReady = true;
      });
  }

  downloadStandingOrdersJson() {
    this.ticketService
      .downloadStandingOrdersJson(this.ticket.id)
      .then((file) => this.fileResponseService.saveAs(file, 'application/json'))
      .busy(this, 'standingOrdersJsonDownloading');
  }

  submit() {
    // prevent user to submit twice
    this.submitReady = false;
    if (
      this.featureAddRemarkToStandingOrders &&
      this.hasRemark &&
      this.remark
    ) {
      this.remarkForm.$submitted = true;

      if (this.remarkForm.$valid) {
        this.ticketService.processStandingOrdersWithRemark(
          this.ticket.id,
          this.remark,
        );
      }

      return;
    }

    this.ticketService.processStandingOrders(this.ticket.id);
  }
}
